import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-mg",
  "use": "icon-icon-mg-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-mg\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#fc3d32\" d=\"M170.7 0H512v256H170.7z\" />\n    <path fill=\"#007e3a\" d=\"M170.7 256H512v256H170.7z\" />\n    <path fill=\"#fff\" d=\"M0 0h170.7v512H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol